export default {
  paygateId: '0a4703c6-d43f-4b12-90fa-eb6d172f3703'
}
